import axios from 'axios';
import { clearStoredToken, getStoredToken } from '../utils/tokenStorage';
import { buildAppUrl, getRuntimeBasePath } from '../utils/runtime';

const normalizeBase = (value) => (value || '').replace(/\/+$/, '');
const BACKEND_URL = normalizeBase(process.env.REACT_APP_BACKEND_URL || getRuntimeBasePath() || '');
const API = `${BACKEND_URL}/api`;

const buildDownloadUrl = (path, params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      query.set(key, value);
    }
  });

  const token = getStoredToken();
  if (token) {
    query.set('auth_token', token);
  }

  const suffix = query.toString();
  return `${API}${path}${suffix ? `?${suffix}` : ''}`;
};

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to all requests
api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearStoredToken();
      window.location.href = buildAppUrl('/login') || '/login';
    }
    return Promise.reject(error);
  }
);

// Cabang
export const getCabang = () => api.get('/cabang');
export const createCabang = (data) => api.post('/cabang', data);
export const updateCabang = (id, data) => api.put(`/cabang/${id}`, data);
export const deleteCabang = (id) => api.delete(`/cabang/${id}`);

// Pemasukan
export const getPemasukan = (params) => api.get('/pemasukan', { params });
export const createPemasukan = (data) => api.post('/pemasukan', data);
export const updatePemasukan = (id, data) => api.put(`/pemasukan/${id}`, data);
export const deletePemasukan = (id) => api.delete(`/pemasukan/${id}`);

// Pengeluaran
export const getPengeluaran = (params) => api.get('/pengeluaran', { params });
export const createPengeluaran = (data) => api.post('/pengeluaran', data);
export const updatePengeluaran = (id, data) => api.put(`/pengeluaran/${id}`, data);
export const deletePengeluaran = (id) => api.delete(`/pengeluaran/${id}`);

// Inventori
export const getInventori = (params) => api.get('/inventori', { params });
export const migrasiInventori = (data) => api.post('/inventori/migrasi', data);

// Dashboard
export const getDashboardSummary = () => api.get('/dashboard/summary');
export const getChartData = () => api.get('/dashboard/chart-data');

// Export PDF
export const exportPemasukan = (cabangId, format = 'pdf') => {
  const suffix = format === 'pdf' ? '' : `.${format}`;
  return buildDownloadUrl(`/export/pemasukan${suffix}`, cabangId ? { cabang_id: cabangId } : {});
};
export const exportPengeluaran = (cabangId, format = 'pdf') => {
  const suffix = format === 'pdf' ? '' : `.${format}`;
  return buildDownloadUrl(`/export/pengeluaran${suffix}`, cabangId ? { cabang_id: cabangId } : {});
};
export const exportInventori = (cabangId, format = 'pdf') => {
  const suffix = format === 'pdf' ? '' : `.${format}`;
  return buildDownloadUrl(`/export/inventori${suffix}`, cabangId ? { cabang_id: cabangId } : {});
};

// CSV Templates
export const templatePemasukan = () => buildDownloadUrl('/template/pemasukan');
export const templatePengeluaran = () => buildDownloadUrl('/template/pengeluaran');

// Import CSV
export const importPemasukan = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/import/pemasukan', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const importPengeluaran = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/import/pengeluaran', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Site Settings
export const getSiteSettings = () => api.get('/site-settings');
export const updateSiteSettings = (formData) => {
  return api.post('/site-settings', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Backups
export const getBackupSettings = () => api.get('/admin/backup-settings');
export const updateBackupSettings = (data) => api.put('/admin/backup-settings', data);
export const getBackups = () => api.get('/admin/backups');
export const runBackup = () => api.post('/admin/backups/run');

export default api;
